/* @flow */
import * as React from 'react';
import MediaObject from 'components/MediaObject.jsx';
import Icon from 'components/Icon.jsx';
import type { ColumnHeader, SortDirection } from './ComposableTable.jsx';

type Props = {
  columnHeader: ColumnHeader,
  sortColumn: ?string,
  sortDirection: ?SortDirection,
  onClick: Function,
  children: React.Node,
};

class ComposableTableSort extends React.Component<Props> {
  determineSortDirection = (sortValue: string) => {
    const { sortColumn, sortDirection } = this.props;

    if (sortValue === sortColumn) {
      return sortDirection === 'asc' ? 'desc' : 'asc';
    }

    return 'asc';
  };

  renderSortIndicator = (columnHeader: ColumnHeader) => {
    const { sortColumn, sortDirection } = this.props;

    if (sortColumn === columnHeader.sortValue) {
      return <Icon name={sortDirection === 'asc' ? 'chevron-up' : 'chevron-down'} size="inherit" />;
    }

    return null;
  };

  handleOnClick = (sortValue: string) => {
    const { onClick } = this.props;
    const sortDirection = this.determineSortDirection(sortValue);
    onClick(sortValue, sortDirection);
  };

  render() {
    const { columnHeader } = this.props;

    return (
      <th
        key={columnHeader.name}
        className={'ComposableTable-sortableHeader'}
        onClick={() => columnHeader.sortValue && this.handleOnClick(columnHeader.sortValue)}>
        <MediaObject center figure="right" gutter="xxsmall" inline>
          {this.props.children}
          {this.renderSortIndicator(columnHeader)}
        </MediaObject>
      </th>
    );
  }
}

export default ComposableTableSort;
